module.exports = __webpack_public_path__ + "img/product-7-qinyou.e8401ec4.png";